import React from 'react';
import { absoluteAfbeeldingsUrl } from '../utils/notitieAfbeeldingen';

/**
 * <img> voor react-markdown: zet de relatieve notitie-URL om naar de backend en houdt
 * de afbeelding binnen de kaart. Gebruik: `<ReactMarkdown components={MARKDOWN_COMPONENTS}>`.
 */
export function MarkdownAfbeelding({ src, alt, node, ...rest }) {
  return (
    <img {...rest} src={absoluteAfbeeldingsUrl(src)} alt={alt || ''} loading="lazy"
      style={{ maxWidth: '100%', height: 'auto', borderRadius: 6, display: 'block', margin: '6px 0' }} />
  );
}

export const MARKDOWN_COMPONENTS = { img: MarkdownAfbeelding };

export default MarkdownAfbeelding;
